import { Sale } from "@/types/sale";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { DATETIME_FORMAT_TABLE } from "../../../../constants/date";
import { SaleItem } from "@/types/saleItem";
import { formatCurrency } from "@/utils/currency";
import { Tag } from "antd";
import { ColumnsProps } from "@/components/table";

export const getColumns = ({
  filterOptions,
  filterValues,
  getSortOrder,
}: ColumnsProps<Sale>): ColumnsType<Sale> => [
  {
    title: "Date",
    dataIndex: "sale_date",
    key: "sale_date",
    sorter: true,
    sortOrder: getSortOrder?.("sale_date"),
    render: (date: string) => dayjs(date).format(DATETIME_FORMAT_TABLE),
  },
  {
    title: "Invoice No.",
    dataIndex: "invoice_no",
    key: "invoice_no",
    sorter: true,
    sortOrder: getSortOrder?.("invoice_no"),
    filters: filterOptions?.invoice_no,
    filterSearch: true,
    filteredValue: filterValues?.invoice_no || null,
  },
  {
    title: "Items",
    dataIndex: "items",
    key: "items",
    sorter: true,
    sortOrder: getSortOrder?.("items"),
    render: (items: SaleItem[]) =>
      items.reduce((sum, item) => sum + (item.quantity || 0), 0),
  },
  {
    title: "Total (IDR)",
    dataIndex: "total_amount",
    key: "total_amount",
    render: (_: number, record: Sale) =>
      formatCurrency(
        Number(record.subtotal || 0) +
          Number(record.tax || 0) -
          Number(record.discount || 0)
      ),
    sorter: true,
    sortOrder: getSortOrder?.("total_amount"),
  },
  {
    title: "Payment",
    dataIndex: "payment_type",
    key: "payment_type",
    sorter: true,
    sortOrder: getSortOrder?.("payment_type"),
    render: (paymentType: string) => {
      switch (paymentType) {
        case "cash":
          return <Tag color="green">Cash</Tag>;
        case "credit_card":
          return <Tag color="blue">Credit Card</Tag>;
        case "qris":
          return <Tag color="pink">QRIS</Tag>;
        case "split":
          return <Tag color="orange">Split</Tag>;
        default:
          return paymentType;
      }
    },
    filters: filterOptions?.payment_type,
    filterSearch: true,
    filteredValue: filterValues?.payment_type || null,
  },
  // {
  //   title: "Actions",
  //   key: "actions",
  //   width: 120,
  //   fixed: "right",
  //   render: (_, record: Sale) => (
  //     <Space size="small">
  //       <Button
  //         type="text"
  //         size="small"
  //         icon={<EditOutlined />}
  //         onClick={() => actions.onEdit(record)}
  //       />
  //       <Popconfirm
  //         title="Delete this sale?"
  //         description="This action cannot be undone."
  //         onConfirm={() => actions.onDelete(record.id)}
  //         okText="Yes"
  //         cancelText="No"
  //       >
  //         <Button type="text" size="small" danger icon={<DeleteOutlined />} />
  //       </Popconfirm>
  //     </Space>
  //   ),
  // },
];

export const getExpandedRowColumns = (): ColumnsType<SaleItem> => [
  {
    title: "Item",
    // dataIndex: ["item", "name"],
    dataIndex: "description",
    key: "product_name",
  },
  // {
  //   title: "Category",
  //   dataIndex: ["item", "category"],
  //   key: "category",
  // },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    title: "Unit Price",
    dataIndex: "unit_price",
    key: "unit_price",
    render: (value: number) => formatCurrency(value),
  },
  {
    title: "Total",
    dataIndex: "total_amount",
    key: "total_amount",
    render: (_: number, record: SaleItem) => {
      const qty = Number(record?.quantity || 0);
      const price = Number(record?.unit_price || 0);
      const total = qty * price;

      return formatCurrency(total);
    },
  },
];
